import React, { useState } from 'react';

import css from '../../../../styles/modules/PaymentSummary/paymentdetails.module.css';
import { Modal } from '@material-ui/core';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { emailFinancials } from '../../../../utils/service/service_api';

export default function ShareModal({
  toast,
  transfer,
  open,
  sendEmail,
  setModalOpen,
}) {
  const [emailFields, setEmailFields] = useState([
    { id: Math.random(), value: '' },
  ]);

  function handleInputChange(e, index) {
    const { value } = e.target;
    const mutatedEmailFields = [...emailFields];
    mutatedEmailFields[index].value = value;
    setEmailFields(() => mutatedEmailFields);
  }

  function addEmailField() {
    if (emailFields.length < 5) {
      const mutableEmailFieldCount = [
        ...emailFields,
        { id: Math.random(), value: '' },
      ];
      setEmailFields(mutableEmailFieldCount);
    }
  }

  async function sendEmail() {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const uniqueEmailAddressList = [
      ...new Set(
        emailFields
          .map((item) => item.value)
          .filter((email) => regex.test(email)),
      ),
    ];

    if (uniqueEmailAddressList.length === 0) {
      toast.error('Please provide a valid email');
      return;
    }

    const data = {
      transfer: { ...transfer, name: 'Client Transfer' },
      TRANSFER_GUID: transfer._id,
      additionalEmailRecipient: uniqueEmailAddressList,
    };

    const res = await emailFinancials(data);

    if (res.data.response === 'success') {
      setModalOpen(false);
      toast.success('Email sent successfully');
    } else {
      setModalOpen(false);
      toast.error('Emails not sent - please contact your administrator');
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => setModalOpen(false)}
      className={css.shareModalWrapper}
    >
      <div className={css.shareModalContent}>
        <p className={css.shareHeadline}>SEND A COPY OF THIS RECEIPT</p>
        <div className={css.shareEmailContentContainer}>
          <p className={css.shareSubHeadline}>Enter Up To 5 Email Addresses</p>
          {emailFields.map((item, index, arr) => {
            return (
              <div key={item.id} className={css.shareInputFieldContainer}>
                <input
                  type="email"
                  onChange={(e) => handleInputChange(e, index)}
                  value={item.value}
                  placeholder={`Email Address ${index + 1}`}
                  className={css.shareInputField}
                />
                <BsFillPlusCircleFill
                  onClick={addEmailField}
                  className={css.plusIcon}
                  style={{
                    visibility: index === arr.length - 1 ? 'visible' : 'hidden',
                  }}
                />
              </div>
            );
          })}
          <div className={css.emailButtonWrapper}>
            <button onClick={sendEmail} className={css.emailButton}>
              Send
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
